export default {
    /**
     * 拉取屏幕屏幕中显示的股票
     * @param start 开始行数
     * @param end 结束行数
     * @param load_ 是否显示加载中
     */
    updataItemDetails(start, end) {
        // 只更新三板的股票列表
        if (this.types === 2) {
            // 只要出发了更新股票列表行情，就算已经初始化了
            this.init = true;
            if (this.timer_) {
                clearTimeout(this.timer_);
            }
            // timeout是scroll节流，防止每次滚动事件触发都频繁请求，只有滚动停止300ms后才请求
            this.timer_ = setTimeout(() => {
                const arr = this.codes.slice(start, end);
                this.$api.getGpDetail(arr.join(',')).then(res => {
                    // 把数据扔给vuex处理
                    if(res.data.code === 1) {
                        this.$store.commit('UPDATE_GP_DETAIL', {data: res.data.data});
                    }
                    if(this.showIng) {
                        this.loading = false;
                        this.$store.commit('UPDATE_SOCKET_IDS', {code_s: arr, t: 'gpList'});
                    }
                });
            }, 300)
        }
    }
}
